'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  display: block;\n  flex: 1;\n  padding: 10px;\n  margin: 0px;\n  background: none;\n  border: none;\n  outline: none;\n  font-family: ProximaNova;\n  font-size: inherit;\n  color: ', ';\n  resize: none;\n\n  &:disabled {\n    color: ', ';\n    pointer-events: none;\n  }\n\n  ', ';\n'], ['\n  width: 100%;\n  height: 100%;\n  display: block;\n  flex: 1;\n  padding: 10px;\n  margin: 0px;\n  background: none;\n  border: none;\n  outline: none;\n  font-family: ProximaNova;\n  font-size: inherit;\n  color: ', ';\n  resize: none;\n\n  &:disabled {\n    color: ', ';\n    pointer-events: none;\n  }\n\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles


var TextareaField = _styledComponents2.default.textarea(_templateObject, _colors.black, _colors.darkGrey, (0, _polished.placeholder)({
  color: _colors.darkGrey,
  'font-family': 'ProximaNova',
  'font-style': 'none'
}));

exports.default = TextareaField;